import { takeEvery } from 'redux-saga/effects';
import * as types from './actionTypes.microphone';
import * as errorSaga from '../errors/saga.errors';
import { IBaseAction } from '../base';

export function* watch() {
    yield takeEvery<IBaseAction>(types.STOP_MICROPHONE, stopMicrophone);
}

export function* stopMicrophone() {
    console.info('stopMicrophone called');
    try {
        window.alanAudio.stop();

    } catch (error) {
        yield errorSaga.putError(error);
    }
}